
<div class="flex flex-column mt-2">
    <div class="flex gap-3">
        @for (category of categories; track $index) {
            <div class="field-checkbox">
                <p-radioButton 
                    [inputId]="category.key"
                    name="category" 
                    [value]="category.key" 
                    [(ngModel)]="selectedCategory"
                    (onClick)="onGroupTypeChange($event.value)"
                    [disabled]="field.disabled"/>
                <label [for]="category.key" class="ml-2">
                    {{ category.name }}
                </label>
            </div>
        }
    </div>
    <p-autoComplete
            #auto
            [(ngModel)]="selectedItems"
            [suggestions]="items"
            (completeMethod)="search($event.query)"
            (onSelect)="onSelectSingleItem($event)"
            [placeholder]="placeholder"
            (onUnselect)="handleSingleUnselect()"
            optionLabel="label"
            minLength="0"
            (onClear)="clearCompleteChange(auto)"
            (onFocus)="handleAutoFocus()"
            class="mi-auto-complete"
            showClear="true"
            [disabled]="selectedCategory !== 'site' || field.disabled">

            <ng-template let-item pTemplate="item">
                <div class="flex align-items-center gap-2">
                    <div class="passenger-popup bold-name">
                        <div class="ellipsis mr-2 font-semibold">
                            {{item?.label}}
                        </div>
                    </div>

                </div>
            </ng-template>
        </p-autoComplete>
        <input style="display: none;" type="text" pInputText [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" class="w-full"/>
</div>